export default __webpack_public_path__ + "static/media/INFO_iconi.b0cf5d82.svg";